import { Folder } from 'lucide-react'
import { cn } from '@/lib/utils'
import { outlookFolderName } from '@/features/order-confirmation/inbox/outlookFolder'

export function OutlookFolderLabel({
  folder,
  className,
  iconClassName,
}: {
  folder: string | null | undefined
  className?: string
  iconClassName?: string
}) {
  const name = outlookFolderName(folder)
  if (!name) return null

  return (
    <span className={cn('inline-flex min-w-0 items-center gap-1', className)}>
      <Folder className={cn('h-3 w-3 shrink-0 text-gray-400', iconClassName)} aria-hidden />
      <span className="truncate">{name}</span>
    </span>
  )
}
